import { Button } from '@mui/material';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import Iconify from '../../../../reusable-components/iconify';
import { buttonStyle } from '../TransitionStyles';

AddMoreButton.propTypes = {
  buttonLabel: PropTypes.string,
  handleAddMoreClick: PropTypes.func,
  disabled: PropTypes.bool,
};

export default function AddMoreButton({ buttonLabel, handleAddMoreClick, disabled }) {
  const isCanceled = useSelector((state) => state.transitions?.data?.isCanceled);

  return (
    <Button
      type="button"
      variant="outlined"
      onClick={handleAddMoreClick}
      sx={{ ...buttonStyle, width: '130px', py: 0.3 }}
      disabled={disabled || isCanceled}
    >
      <Iconify icon="eva:plus-fill" />
      {buttonLabel}
    </Button>
  );
}
